import React from 'react';
import BaseSelector, { SelectProps } from '@/components/selectors/BaseSelector';
import { ValidationRule } from '@core/utils/validation.ts';
import { useFormField } from '@core/hooks/useFormField';

export interface FormMultiSelectProps extends Omit<
    SelectProps,
    'error' | 'helperText' | 'onBlur' | 'multiple' | 'value' | 'onChange'
> {
    name: string;
    value: string[];
    rules?: ValidationRule[];
    helperText?: string;
    required?: boolean;
    onChange?: (value: string[]) => void;
}

const FormMultiSelect: React.FC<FormMultiSelectProps> = ({
    name,
    rules = [],
    value,
    onChange,
    helperText: staticHelperText,
    ...selectProps
}) => {
    const { error, showError, handleBlur, handleChange } = useFormField({
        name,
        value,
        label: selectProps.label,
        rules,
        onChange
    });

    return (
        <BaseSelector
            {...selectProps}
            multiple
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            error={showError}
            helperText={showError ? error : staticHelperText}
            data-form-field={name}
        />
    );
};

FormMultiSelect.displayName = 'FormMultiSelect';

export default FormMultiSelect;
